﻿import { UDViewModel as ApiUDViewModel, UDViewCommonSettingsItem } from '../services/axios/axios-api-v2-generated';
import { createSettingsPath, extractKeyPaths } from './settings-utils';
import { UDViewAirportSettingsModel } from './udview';

export const DEFAULT_AIRPORT_NAV_SETTINGS: UDViewAirportSettingsModel = {
    fontSize: 10,
    airportLabelType: 'faa',
    activeRunwayDepiction: true,
    departureColor: 'rgba(48,48,240, 1)',
    arrivalColor: 'rgba(225, 0, 255, 1)',
    directionIndicator: true,
    rangeRingsEnabled: false,
    rangeRingsLineColor: 'rgba(0, 0, 0, 1)',
    rangeRingsLineStyle: 'solid',
    rangeRingsFillColor: 'rgba(139,193,201, 1)',
    rangeRingsFillStyle: 'none',
    rangeRingsOpacity: 0.25,
    rangeRingsSingleRing: false,
    rangeRingsSingleRingDistance: 100,
    rangeRingsMultipleRings: 3,
    rangeRingsMultipleRingSpacing: 20,
    applyToAllAirports: true,
    selectedGroupId: null,
    runwayLabels: true,
    runwayWindIndicators: true,
    runwayWindGust: true,
    runwayWindGustFactor: 1.0,
    runwayRvrIndicators: true
} as const;

const navPaths = extractKeyPaths(
    Object.keys(DEFAULT_AIRPORT_NAV_SETTINGS) as Array<keyof UDViewAirportSettingsModel>,
    DEFAULT_AIRPORT_NAV_SETTINGS
).map(createSettingsPath);

export function airportNavSettingsToApi(
    userSettings: UDViewAirportSettingsModel,
    includeDefaults: boolean = false
): UDViewCommonSettingsItem[] {
    const modified: { key: string; value: string }[] = [];
    for (const path of navPaths) {
        const defaultValue = path.getter(DEFAULT_AIRPORT_NAV_SETTINGS);
        const user = path.getter(userSettings);
        if (includeDefaults || defaultValue !== user) {
            modified.push({ key: path.key, value: JSON.stringify(user) });
        }
    }
    return modified;
}

export function airportNavSettingsFromApi(view: ApiUDViewModel): UDViewAirportSettingsModel {
    const settings = structuredClone(DEFAULT_AIRPORT_NAV_SETTINGS);

    if (view && view.staticData?.airport?.settings) {
        const udViewSettings = view.staticData.airport.settings;

        for (const entry of navPaths) {
            const idx = udViewSettings.findIndex((x) => x.key === entry.key);
            if (idx < 0) {
                continue;
            }

            if (!udViewSettings[idx].value) {
                console.warn(`Missing value for nav setting ${entry.key}`);
                continue;
            }

            const value = JSON.parse(udViewSettings[idx].value);
            entry.setter(settings, value);
        }
    }

    return settings;
}
